import styled from "styled-components";
import { Accent, BackgroundColor, BackgroundColorLight, Green, PrimaryColor, SecondaryColor, TextColor, TextColorDark, TextColorLight } from "../../styles/global";
import { Container } from "../../styles/styles";



export const Employee = styled(Container)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  color: #000;
  border-radius: 8px;
  width: fit-content;
  padding: 20px;
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
  margin-top: -70px;

  p, h3 { color: #000; }
  p, small { font-size: 14px; }
  p { font-weight: 500; }
  small { font-weight: lighter; }

  .employee-details {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 0px;
    flex: 1;
    text-align: left;
    small { width: max-content; }
  }

  .employee-icon-div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: none;
    text-align: center;
    padding: 22px;
  }
  
  .employee-icon {
    color: ${SecondaryColor};
  }
`;

export const EmployeeActionItem = styled(Container)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 50px;

  p{font-weight: 400;}
  span{font-size: 25px; width:auto;}
  svg{color: ${PrimaryColor};width:auto;}

  .employee-icon-div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: none;
    text-align: center;
    padding: 10px;
    svg{color: ${TextColorLight};}
  }
  
  .employee-icon {
    color: ${TextColorLight};
    
  }

  &:hover {
    background-color: ${BackgroundColorLight};
    p,svg{color: ${TextColorLight};}
  }
`;

export const LogoutButton = styled.button`
  background-color: ${BackgroundColor};
  border: solid 2px ${PrimaryColor};
  color: ${TextColor};
  padding: 5px 60px;
  border-radius: 50px;
  font-size: 18px;
  cursor: pointer;
  align-self: center;

  &:hover {
    background-color: ${PrimaryColor};
    color: ${TextColorLight};
  }
`;

export const RequiredText = styled.p`
  font-size: 12px;
  color: ${TextColorLight}!important;
  margin-top: -15px;
  align-self: flex-start;
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 10px;
  color: ${TextColorLight};
`;

export const Aviso = styled(Container)`
    background-color: ${BackgroundColorLight};
    p, a{color: ${TextColorLight};}
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border-radius: 8px;
    font-size: 14px;
`;


// edit.js

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 600px;
  /* padding: 20px; */
  background-color: none;
  border-radius: 10px;
  align-items: center;
  margin-top: -60px;
  h2{
    color: ${TextColorLight};
  }

`;

export const Label = styled.p`
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: ${TextColorLight}!important;
  align-self: flex-start;
  margin-bottom: -12px;
`

export const InputField = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: none;
  background-color: ${TextColorLight};
  color: #000;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  

  &::placeholder {
    color: #000;
  }

  &:disabled {
    color: ${TextColorDark};
    background-color: #cacaca;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: none;
  min-height: 130px;
  color: ${TextColor};

  &::placeholder {
    color: ${TextColor};
  }
`;

export const SelectField = styled.select`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: none;
  background-color: ${TextColorLight};
  color: #000;
  font-family: "Roboto", sans-serif;
  font-size: 12px;

  > option {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
  }

`;

export const SubmitButton = styled.button`
  background-color: ${Green};
  padding: 10px 70px;
  border-radius: 30px; 
  border: none;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  cursor: pointer;
  justify-

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

//view.js
export const UserListTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-radius: 8px;

    thead {
        background-color: ${PrimaryColor};
        color: ${TextColorLight};
        border-radius: 8px;

        th {
            padding: 8px;
            text-align: left;
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid ${Accent};
            &:hover {
                background-color: ${Accent};
            }

            td {
                padding: 5px;
                color: ${TextColorDark};
                font-size: 13px;

                button {
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 5px;
                }

                svg {
                    width: 20px;
                    height: 20px;
                    color: ${PrimaryColor};
                }

                svg:hover {
                    color: ${TextColorDark};
                }
            }
        }
    }
`;
